import React, { useState, useEffect } from "react";
import axios from "axios";
import { APILINK } from "../../EndPoint";
import ErrorHandler from "../../error-handler/ErrorHandler";
import { Container, Row, Col, Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { Button, Select } from "antd";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useTranslation } from "react-i18next";
import "react-toastify/dist/ReactToastify.css";
import { connect } from "react-redux";
import "../../stylesheets/detailsForm.css";
import axiosInstance from "../../api/axiosInstance";

const axiosApiInstance = axios.create();
const EditDocument = (props) => {
    const { t } = useTranslation();
    const [disabled, setDisabled] = useState(false);
    const [data, setData] = useState("")
    const {
        register,
        handleSubmit,
        control,
        formState: { errors },
        setValue,
        watch,
    } = useForm();

    const [categoriesName, setCategoriesName] = useState([]);
    const [categoriesID, setCategoriesID] = useState();
    const [categories, setCategories] = useState([]);
    const [nextUrl, setNext] = useState("");
    const [loadCategories, setLoadCat] = useState(false);


    const getCategories = async () => {
        let result = await axiosInstance.get(`/get_category?page=1`);
        setCategories(result.data.data);
        setNext(result.data.next);
        
    };
    const getDetails = async () => {
        let result = await axiosInstance.get(`/document/${props.match.params.id}`)
        if (result) {
            console.log(result.data)
            setData(result.data)
        }
            console.log(categories)
            categories.map((key) => {
                console.log(categories)

                let selectedCatsNames = data?.categories.filter(category => category === key.id)
                console.log(selectedCatsNames)

            }

            );

    }
    const onSubmit = async (data) => {
        setDisabled(true);
        data.categories = categoriesID;
        for(let key in data){
            if(data[key] === ""){
                delete data[key]
            }
        }
        console.log(data);
        let result;

        result = await axiosInstance
          .put(`/document/${props.match.params.id}`, data)
          .catch((err) => {
            console.log(err.response);
            setDisabled(false);
            for (const error in err.response.data.error) {
              console.log(err.response.data.error[error][0]);
              setTimeout(() => {
                toast.error(`${err.response.data.error[error][0]}`);
              }, 500);
            }
          });

        console.log(result);
        if (result) {
          setTimeout(() => {
            toast.info(t("success"));
          }, 500);
          setDisabled(false);
        }
    };


    useEffect(() => {
        getCategories()
        getDetails()
    }, []);

    const handleCategories = (v, e) => {
        console.log(v)
        let selectedCats = [...v]
        let appendedCats = [...selectedCats,v[-1]]
        setCategoriesID(v)
    };
    const onScroll = async (event) => {
        var target = event.target;
        if (
            target.scrollTop + target.offsetHeight === target.scrollHeight
        ) {
            target.scrollTo(0, target.scrollHeight);

            if (nextUrl !== null) {
                const result = await axiosInstance.get(`${nextUrl}`);
                setNext(result.data.next);
                var children = [...categories, ...result.data.data];
                setCategories(children);
            }
        }
    };
    useEffect(() => {
        setLoadCat(false)
    }, [categories])
    return (
        <Container
            style={{
                textAlign: localStorage.getItem("lang") == "ar" ? "right" : "left",
            }}
            className=" align-left usersForm"
        >
            <Row>
                <Col lg={12}>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <Row>
                            <h4 className="title">{t("editDocument")}</h4>
                            <Col lg={6}>
                                <label className="label"> {t("documentForm.arName")}</label>
                                <Form.Control defaultValue={data.title_ar} {...register("title_ar")} />

                                <p className="error">
                                    {errors.title_ar?.type === "required" && t("errors.required")}
                                </p>
                            </Col>

                            <Col lg={6}>
                                <label className="label">{t("documentForm.enName")}</label>

                                <Form.Control
                                    type="text"
                                    defaultValue={data.title_en}
                                    {...register("title_en")}
                                />
                                <p className="error">
                                    {errors.title_en?.type === "required" && t("errors.required")}
                                </p>
                            </Col>
                        </Row>

                        <Row>
                            <Col lg={6}>
                                <label className="label"> {t("documentForm.categories")}</label>
                                <Select
                                    mode="multiple"
                                    allowClear
                                    placeholder={t("documentForm.categories")}
                                    defaultValue={data.categories}
                                    onChange={handleCategories}
                                    style={{ width: "100%" }}
                                    onPopupScroll={onScroll}
                                >
                                    {categories.map((category) => (
                                        <Select.Option key={category.id} value={category.id} id={category.id}
                                        >
                                            {category.title_ar} - {category.title_en}
                                        </Select.Option>
                                    ))}
                                </Select>
                            </Col>
                        </Row>

                        <div className="formSubmit">
                            <button
                                disabled={disabled}
                                className="defaultButton"
                                type="submit"
                                onClick={handleSubmit(onSubmit)}
                            >
                                {t("buttons.finish")}
                            </button>
                        </div>
                    </form>
                </Col>
            </Row>

            <ToastContainer position="bottom-right" />
        </Container>
    );
};

const mapStateToProps = (state) => ({
    user: state.auth.user,
});

export default connect(
    mapStateToProps,
    null
)(ErrorHandler(EditDocument, axiosInstance));
